/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum ResultaatBijzonderheid {
    TELT_NIET_MEE = "Telt niet mee",
    VRIJSTELLING = "Vrijstelling",
    NIET_GEMAAKT = "Niet gemaakt"
}
